import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImagePipe } from './image.pipe';
import { DolarPipe } from './dolar.pipe';
import { SearchPipe } from './search.pipe';



@NgModule({
  declarations: [
    ImagePipe,
    DolarPipe,
    SearchPipe,
    SearchPipe
  ],
  imports: [
    CommonModule
  ],
  exports: [
    ImagePipe,
    DolarPipe,
    SearchPipe
  ]
})
export class PipeModule { }
